import isServer from './isServerForSSR';
import global from './global';

const getHostname = (hostname?: string, subdomain?: string) => {
  const hostnameValue = hostname || global.circleci?.config?.hostname;
  if (!isServer && !hostnameValue) {
    throw new Error('hostname is not configured');
  }
  if (subdomain) {
    return `${subdomain}.${hostnameValue}`;
  } else {
    return hostnameValue;
  }
};

export default getHostname;
